<template>
  <EditableArea
    v-if="content"
    :content="content?.[area]"
  />
</template>

<script lang="ts" setup>
import { EditableArea } from '@magnolia/vue-editor';
import { usePageLoader } from '~/composables/custom/usePageLoader/usePageLoader';
import { useSSR } from '~/composables/useSSR/useSSR';

const { onSSR } = useSSR();

interface Props {
  page?: string;
  area?: string;
}

const props = withDefaults(defineProps<Props>(), {
  page: '',
  area: 'area1',
});

const { content, fetchContent } = usePageLoader('page-content');

onSSR(async () => {
  await fetchContent(props.page);
});
</script>
